import component from './analytics_chart_doughnut.vue'
export default component
